
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'Contact',

  data() {
    return {
      contactApi: new this.$ApiModel(),
      faQuestionCircle
    }
  },

  computed: {
    compHasSentForm() {
      return !!this.contactApi.response.data?.success
    }
  },

  created() {
    if (this.$app.isAuth && this.$app.user?.fullName) {
      this.contactApi.model.name = this.$app.user.fullName
      this.contactApi.model.email = this.$app.user.email
      this.contactApi.model.mobileNumber = this.$app.user.mobileNumber
    }
  },

  methods: {
    async sendContactForm() {
      await this.$api.system(this.contactApi).sendContactMessage()

      const eventElement = await this.$elementReady.selector(`#complete-notification`)

      this.$scroll.intoViewIfNeeded(eventElement)
    },

    viewFaqs() {
      if (!this.$app.isNative) {
        this.$redirect.to('/faqs')
        this.$modal.closeAll()
      } else {
        this.$modal.open('global/faqs')
      }
    }
  }
}
